import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../axios';
import MatxLoading from "../components/MatxLoading";

const initialValue = {
    topCards: {
        active_products: 0,
        total_sale: 0,
        completed_orders: 0,
        orders_to_deliver: -1
    },
    top_Selling_areas: [],
    vendors: [],
    bottomCards: {
        active_users: 0,
        active_sellers: 0,
    },
    top_selling_products: [],
    feature_products: []
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                dashboard_data: action.payload,
            }
        }
        case 'REMOVE_FEATURED': {
            state.dashboard_data.feature_products.splice(action.payload.index,1);
            return {
                ...state,
                dashboard_data: state.dashboard_data,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const DashboardContext = createContext({
    dashboard_data: initialValue,
    getDashboardData: () => {},
    remove_featured: () => {},
})

export const DashboardProvider = ({settings, children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)


    const getDashboardData = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/dashboard/top_cards_details', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }


    const remove_featured = async (product_id, index) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/remove_featured/${product_id}`, options);

            if(res.status === 200) {
                res.data.index = index;
                dispatch({
                    type: 'REMOVE_FEATURED',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getDashboardData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // if(state.dashboard_data === undefined) {
    //     return <MatxLoading />
    // }

    return (
        <DashboardContext.Provider
            value={{
                dashboard_data: state?.dashboard_data,
                getDashboardData,
                remove_featured
            }}
        >
            {children}
        </DashboardContext.Provider>
    )
}

export default DashboardContext
